import { Link } from 'react-router-dom'

export default function PageHero({ eyebrow, title, intro, action }: { eyebrow: string; title: string; intro: string; action?: { label: string; to: string } }) {
  return <section className="page-hero">
    <div className="page-hero-grid" aria-hidden="true"/><div className="container"><p className="eyebrow">{eyebrow}</p><h1>{title}</h1><p>{intro}</p>{action && <Link className="btn primary" to={action.to}>{action.label}<span>↗</span></Link>}</div>
  </section>
}
